import Base from "components/Base";
import { useToastContext } from "components/alert/ToastContext";
import Pageable from "model/page/Pageable";
import ApontamentoOP from "model/producao/ApontamentoOP";
import EstagioOP from "model/producao/EstagioOP";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTableStateEvent } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import ApontamentoOpService from "service/producao/ApontamentoService";

const apontamentoOpService = new ApontamentoOpService();

function EstagiosApontamentoListagem() {

    const navigate = useNavigate();
    const [pageableOpsIniciar, setPageableOpsIniciar] = useState(new Pageable(0, 10, "ordemProducao.numero", 0));
    const [totalElementsOpsIniciar, setTotalElementsOpsIniciar] = useState<number>(0);
    const [opsIniciar, setOpsIniciar] = useState<EstagioOP[]>([]);
    const [pageableOpsAndamento, setPageableOpsAndamento] = useState(new Pageable(0, 10, "ordemProducao.numero", 0));
    const [totalElementsOpsAndamento, setTotalElementsOpsAndamento] = useState<number>(0);
    const [opsAndamento, setOpsAndamento] = useState<EstagioOP[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const rows = 10;

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {
        setLoading(true);
    }, []);

    useEffect(() => {
        if (loading) {
            const idEstagio = parseInt(window.location.pathname.substring(`/apontamentoOp/listagem/`.length))

            apontamentoOpService.pesquisar(pageableOpsIniciar, [], idEstagio, 'LIBERADO').then(page => {
                setOpsIniciar(page.content);
                setTotalElementsOpsIniciar(page.totalElements);
            }).catch(error => {
                console.error(error);
                if (error.data.message) {
                    msgAlerta("Alerta", error.data.message);
                    console.error(error.data.message);
                }
            });

            apontamentoOpService.pesquisar(pageableOpsAndamento, [], idEstagio, 'EM_ANDAMENTO').then(page => {
                setOpsAndamento(page.content);
                setTotalElementsOpsAndamento(page.totalElements);
            }).catch(error => {
                console.error(error);
                if (error.data.message) {
                    msgAlerta("Alerta", error.data.message);
                    console.error(error.data.message);
                }
            });

            setLoading(false);
        }
    }, [loading, pageableOpsIniciar, pageableOpsAndamento]);

    const onPageOpsIniciar = (event: DataTableStateEvent) => {
        setPageableOpsIniciar({ ...pageableOpsIniciar, page: event.page !== undefined ? event.page : 0, first: event.first });
        setLoading(true);
    };

    const onPageOpsAndamento = (event: DataTableStateEvent) => {
        setPageableOpsAndamento({ ...pageableOpsAndamento, page: event.page !== undefined ? event.page : 0, first: event.first });
        setLoading(true);
    };

    const iniciarEstagio = (estagioOp: EstagioOP) => {

        let apontamentoOp = new ApontamentoOP();
        apontamentoOp.estagioOP = estagioOp;
        apontamentoOp.tipo = "INICIO"

        apontamentoOpService.apontar(apontamentoOp).then(data => {
            navigate(`/apontamentoOp/apontar/${estagioOp.id}`)
        }).catch(error => {
            console.error(error);
            if (error.data.message) {
                console.error(error.data.message);
            }
        });
    }

    const retomarEstagio = (estagioOp: EstagioOP) => {
        navigate(`/apontamentoOp/apontar/${estagioOp.id}`)
    }


    return (
        <Base tituloPagina={"Escolher estágio"}>

            <TabView>
                <TabPanel header="Aguardando início">
                    <DataTable
                        emptyMessage="Nenhum registro encontrado"
                        value={opsIniciar}
                        paginator lazy rows={rows}
                        first={pageableOpsIniciar.first} totalRecords={totalElementsOpsIniciar} onPage={onPageOpsIniciar}
                        loading={loading}>
                        <Column field="ordemProducao.numero" header="Nr. OP" />
                        <Column field="ordemProducao.produto.nome" header="Produto" />
                        <Column field="ordemProducao.qtPrevista" header="Quantidade" />
                        <Column field="ordemProducao.lote" header="Lote" />
                        <Column field="ordemProducao.itemPedido.pedido.cliente.nome" header="Cliente" />
                        <Column header="" body={(rowData: EstagioOP) => {
                            return <Button label="Iniciar" onClick={() => {
                                iniciarEstagio(rowData);
                            }} />
                        }} />
                    </DataTable>


                </TabPanel>

                <TabPanel header="Em andamento">
                    <DataTable
                        emptyMessage="Nenhum registro encontrado"
                        value={opsAndamento}
                        paginator lazy rows={rows}
                        first={pageableOpsAndamento.first} totalRecords={totalElementsOpsAndamento} onPage={onPageOpsAndamento}
                        loading={loading}>
                        <Column field="ordemProducao.numero" header="Nr. OP" />
                        <Column field="ordemProducao.produto.nome" header="Produto" />
                        <Column field="ordemProducao.qtPrevista" header="Quantidade" />
                        <Column field="ordemProducao.lote" header="Lote" />
                        <Column field="ordemProducao.itemPedido.pedido.cliente.nome" header="Cliente" />
                        <Column header="" body={(rowData: EstagioOP) => {
                            return <Button label="Retomar" onClick={() => {
                                retomarEstagio(rowData);
                            }} />
                        }} />
                    </DataTable>
                </TabPanel>


            </TabView>

        </Base>
    );
}

export default EstagiosApontamentoListagem;